import {Editor} from '@tinymce/tinymce-react';
import { action, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {tinyMceConfig} from '../../../../lib/helpers';
import {AddContentStore} from '../../x7/content-parts/AddContentStore';

const TinyMceInit = tinyMceConfig.init;

@observer
export class X9StaticHtmlCreate extends React.Component<{ store: AddContentStore }> {
  @action
  handleEditorChange = (content: string) => {
    this.props.store.setContents(content);
  };

  constructor(props: { store: AddContentStore }) {
    super(props);
    makeObservable(this);
  }

  render() {
    return (<Editor init={TinyMceInit}
                    value={this.props.store.contents}
                    onEditorChange={this.handleEditorChange}/>);
  }
}
